import { Alert, Button, Collapse, Typography } from '@mui/material';
import { AnimatePresence, motion } from 'motion/react';
import { OverallAgentHealth, useReconnectAgent } from '../hooks/useAgentHealthStatus';

export function AgentStatus({
  status,
  isAutoReconnecting,
}: {
  status: OverallAgentHealth;
  isAutoReconnecting: boolean;
}) {
  const { handleRetry, isRetrying } = useReconnectAgent();

  const isReconnecting = isRetrying || isAutoReconnecting;

  const alertContent = (
    <Alert severity='warning' sx={{ minHeight: '3.5rem' }}>
      The assistant is currently unavailable. <br />
      <Typography variant='body2' alignItems='center' height='1.75rem'>
        <AnimatePresence mode='wait'>
          <motion.div
            key={isReconnecting ? 'reconnecting' : 'error'}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            {isReconnecting ? (
              <>Reconnecting...</>
            ) : (
              <>
                Please
                <Button variant='text' onClick={handleRetry}>
                  try again
                </Button>
                later.
              </>
            )}
          </motion.div>
        </AnimatePresence>
      </Typography>
    </Alert>
  );

  const showAlert = status === 'error' || isReconnecting;

  return (
    <Collapse in={showAlert} sx={{ position: 'sticky', bottom: 0, zIndex: 1, translateY: '-100%' }}>
      {showAlert ? alertContent : <div style={{ height: '1px' }} />}
    </Collapse>
  );
}
